import Turnos from "./Turnos";
export default Turnos;